import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/group-v2.0.0'

export default reactNode(
	'Group',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: true, docs: '' }
)
